import { useCallback, useRef } from "react";

/**
 * Simple hook to trigger a useEffect only once, no matter what other rerenderings might happen
 * Check if this is the first rerender with `isFirst()`
 * Then right after, use `executeFirst()` to toggle.
 */
export default function useEffectOnce() {
  const firstRef = useRef<true | null>(null);

  const isFirst = useCallback(() => {
    return firstRef.current === null;
  }, [firstRef]);

  const executeFirst = useCallback(() => {
    firstRef.current = true;
  }, [firstRef]);

  return { isFirst, executeFirst };
}
